import React from 'react';
import { XCircle, AlertTriangle, Calendar, DollarSign, CheckCircle } from 'lucide-react';
import { formatarMoeda } from '../utils';
import FinanceStatCards from '../../financeShared/FinanceStatCards';

const HeaderStats = ({ 
  totalVencidas, 
  totalProntasParaPagar, 
  totalProximosMeses,
  totalPagas = 0,
  totalRegistrosProntasParaPagar = 0,
  totalRegistrosVenceHoje = 0,
  filtroAtivo = 'todas',
  loading = false,
  onChangeFiltro = null
}) => {
  const contextoCardProntas =
    totalRegistrosProntasParaPagar > 0
      ? `${totalRegistrosProntasParaPagar} título${totalRegistrosProntasParaPagar === 1 ? '' : 's'} pronto${totalRegistrosProntasParaPagar === 1 ? '' : 's'} • ${totalRegistrosVenceHoje} venc${totalRegistrosVenceHoje === 1 ? 'e' : 'em'} hoje`
      : 'Sem títulos prontos no momento';

  const cards = [
    {
      id: 'vencidas',
      title: 'Contas Vencidas',
      value: formatarMoeda(totalVencidas),
      Icon: XCircle,
      tone: 'danger',
      active: filtroAtivo === 'vencidas',
      onClick: onChangeFiltro ? () => onChangeFiltro('vencidas') : undefined,
    },
    {
      id: 'prontas_para_pagar',
      title: 'Prontas para Pagar',
      value: formatarMoeda(totalProntasParaPagar),
      Icon: AlertTriangle,
      tone: 'warning',
      featured: true,
      context: contextoCardProntas,
      active: filtroAtivo === 'prontas_para_pagar',
      onClick: onChangeFiltro ? () => onChangeFiltro('prontas_para_pagar') : undefined,
    },
    {
      id: 'pagas',
      title: 'Pagas',
      value: formatarMoeda(totalPagas),
      Icon: CheckCircle,
      tone: 'good',
      active: filtroAtivo === 'pagas',
      onClick: onChangeFiltro ? () => onChangeFiltro('pagas') : undefined,
    },
    {
      id: 'proximos_3_meses',
      title: 'Próximos 3 Meses',
      value: formatarMoeda(totalProximosMeses),
      Icon: Calendar,
      tone: 'info'
    },
    {
      id: 'todas',
      title: 'Total Geral',
      value: formatarMoeda(totalVencidas + totalProntasParaPagar + totalProximosMeses),
      Icon: DollarSign,
      tone: 'good',
      active: filtroAtivo === 'todas',
      onClick: onChangeFiltro ? () => onChangeFiltro('todas') : undefined,
    }
  ];

  return (
    <FinanceStatCards
      cards={cards}
      loading={loading}
      ariaLabel="Resumo financeiro de contas a pagar"
      interactiveOnDesktop={false}
      layout="balanced-five-desktop"
    />
  );
};

export default HeaderStats;
